import React from "react";
import ViaHeaderSimple from "../../components/layout/ViaHeaderSimple";
import { withRouter } from "react-router-dom";
import { entryRoutes } from "../../utility/route-locations";
import { FormattedMessage, useIntl } from "react-intl";
import {Row, Col, Typography, Button} from "antd";
import LocaleSelector from "../../components/translations/LocaleSelector";
import {asViaUrl} from "../../utility/via-fetch";

const { Title, Text } = Typography;

/**
 * A component for displaying a support message for a user not logged in.
 */
function AccountDeletionExternal() {
    const intl = useIntl();

    return (
        <div className="via-layout via-image-bg" style={{ width: '100%', justifyContent: 'flex-start' }}>
            <ViaHeaderSimple />
            <div className="via-centre-box" align="center">
                <Row style={{ marginTop: '10px' }}>
                    <Col span={24}>
                        <Title>{ intl.formatMessage({ id: 'accountDeletionTitle' })}</Title>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px', marginLeft: '10px', marginRight: '10px' }}>
                    <Col span={24}>
                        <Text>{ intl.formatMessage({ id: 'accountDeletionBlurb1' })}</Text>
                        <br />
                        <Text>{ intl.formatMessage({ id: 'accountDeletionBlurb2' })}</Text>
                    </Col>
                </Row>
                <Row style={{ marginTop: '20px', marginBottom: '30px' }}>
                    <Col span={24}>
                        <Button type="primary" onClick={() => window.location.assign(asViaUrl(`${entryRoutes.contactUsWithDelete}`))}>
                            <span><FormattedMessage id="goto" /> <FormattedMessage id="login" /></span>
                        </Button>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px', marginLeft: '10px', marginRight: '10px' }}>
                    <Col span={24}>
                        <Text>{ intl.formatMessage({ id: 'accountDeletionDescriptor' })}</Text>
                    </Col>
                </Row>
                <Row style={{ marginTop: '30px', marginLeft: '10px', marginRight: '10px' }}>
                    <Col span={24}>
                        <Text><ul>{ intl.formatMessage({ id: 'accountDeletionWhat1' })}</ul></Text>
                        <Text><li>{ intl.formatMessage({ id: 'accountDeletionWhat2' })}</li></Text>
                        <Text><li>{ intl.formatMessage({ id: 'accountDeletionWhat3' })}</li></Text>
                        <Text><li>{ intl.formatMessage({ id: 'accountDeletionWhat4' })}</li></Text>
                    </Col>
                </Row>
                <Row style={{ marginTop: '130px', marginBottom: '12px' }}>
                    <FormattedMessage id="translatePage" />
                </Row>
                <Row type="flex" justify="center" style={{ marginBottom: '30px' }}>
                    <LocaleSelector />
                </Row>
            </div>
        </div>
    );
}

export default withRouter(AccountDeletionExternal);